import { useRef, useState } from 'react';
import clsx from 'clsx';
import { useButton } from 'react-aria';
import { Toast, ToastVariant, useToast } from '@hungryroot/components-toast';
import { getImageProps } from '@hungryroot/image';
import { Badge, BadgeVariant } from '@hungryroot/pho';
import { Paragraph } from '@hungryroot/ramen';
import { PDPModal } from '@hungryroot/rdp';
import { PeriodicityTypes } from '@hungryroot/rest';
import { OSNButtonGroup } from './OSNButtonGroup';
import styles from './GroceryItemCard.module.css';
import sharedCardStyles from './sharedCardStyles.module.css';

type GroceryItemCardProps = {
  grocery: {
    id: number;
    isNew: boolean;
    cardImageUrl: string | null;
    brandName: string;
    periodicity: PeriodicityTypes | null;
    name: string;
  };
};

export function GroceryItemCard(props: GroceryItemCardProps) {
  const { grocery } = props;

  const [showPDP, setShowPDP] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  const { buttonProps } = useButton(
    {
      elementType: 'div',
      onPress: () => setShowPDP(true),
    },
    ref
  );

  const { toast } = useToast();

  return (
    <div className={clsx(sharedCardStyles.card, styles.card)}>
      {showPDP ? (
        <PDPModal
          id={grocery.id}
          onDismiss={() => setShowPDP(false)}
          stacked={false}
          onBackClick={() => setShowPDP(false)}
          showOSNSection={true}
        />
      ) : null}

      <div {...buttonProps} className={styles['grocery-item-button']} ref={ref}>
        <div className={styles['image-container']}>
          {grocery.cardImageUrl ? (
            <img
              className={styles.image}
              {...getImageProps({ src: grocery.cardImageUrl, width: 300 })}
              alt={grocery.name}
            />
          ) : null}
          {grocery.isNew ? (
            <Badge className={styles['new-badge']} variant={BadgeVariant.New}>
              <Paragraph variant="caption">New</Paragraph>
            </Badge>
          ) : null}
        </div>

        <div className={styles['grocery-item-info']}>
          <Paragraph
            className={styles['grocery-item-brand-name']}
            variant="caption"
          >
            {grocery.brandName}
          </Paragraph>
          <Paragraph className={styles['grocery-item-name']} variant="lead">
            {grocery.name}
          </Paragraph>
        </div>
      </div>
      <OSNButtonGroup
        onChange={({ option }) => {
          if (option === PeriodicityTypes.NEVER) {
            toast(
              <Toast
                className={styles['never-toast']}
                variant={ToastVariant.Neutral}
              >
                We'll adjust your order within 24 hrs to remove items marked as
                "Never". Edited orders won't be updated.
              </Toast>
            );
          }
        }}
        className={styles['osn-buttons']}
        productId={grocery.id}
      />
    </div>
  );
}
